import { render, staticRenderFns } from "./PostcodeZones.vue?vue&type=template&id=cc48d668&scoped=true&"
import script from "./PostcodeZones.vue?vue&type=script&lang=ts&"
export * from "./PostcodeZones.vue?vue&type=script&lang=ts&"
import style0 from "./PostcodeZones.vue?vue&type=style&index=0&id=cc48d668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc48d668",
  null
  
)

export default component.exports